module.exports = __webpack_public_path__ + "img/Loader-sm-en.af72868f.gif";